import request from 'services/axios';

export const wantedPost = async (payload: wantedBody) => {
  const {data} = await request.post(`/api/v2/market/wanted-post`, {
    ...payload,
  });
  return data;
};
